/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_Columns_SizeInputs */

const id_builds_comparison_columns_size = /** @type {(inputs: Builds_Comparison_Columns_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sebelum → sesudah`)
};

const ms_builds_comparison_columns_size = /** @type {(inputs: Builds_Comparison_Columns_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sebelum → selepas`)
};

const da_builds_comparison_columns_size = /** @type {(inputs: Builds_Comparison_Columns_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Før → efter`)
};

const de_builds_comparison_columns_size = /** @type {(inputs: Builds_Comparison_Columns_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorher → nachher`)
};

const en_us2_builds_comparison_columns_size = /** @type {(inputs: Builds_Comparison_Columns_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before → after`)
};

const es_es2_builds_comparison_columns_size = /** @type {(inputs: Builds_Comparison_Columns_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antes → después`)
};

const es_mx2_builds_comparison_columns_size = /** @type {(inputs: Builds_Comparison_Columns_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antes → después`)
};

const fil_builds_comparison_columns_size = /** @type {(inputs: Builds_Comparison_Columns_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bago → pagkatapos`)
};

const fr_builds_comparison_columns_size = /** @type {(inputs: Builds_Comparison_Columns_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avant → après`)
};

const it_builds_comparison_columns_size = /** @type {(inputs: Builds_Comparison_Columns_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prima → dopo`)
};

const hu_builds_comparison_columns_size = /** @type {(inputs: Builds_Comparison_Columns_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Előtte → utána`)
};

const nl_builds_comparison_columns_size = /** @type {(inputs: Builds_Comparison_Columns_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voor → na`)
};

const no_builds_comparison_columns_size = /** @type {(inputs: Builds_Comparison_Columns_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Før → etter`)
};

const pl_builds_comparison_columns_size = /** @type {(inputs: Builds_Comparison_Columns_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przed → po`)
};

const pt_br2_builds_comparison_columns_size = /** @type {(inputs: Builds_Comparison_Columns_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antes → depois`)
};

const pt_builds_comparison_columns_size = /** @type {(inputs: Builds_Comparison_Columns_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antes → depois`)
};

const ro_builds_comparison_columns_size = /** @type {(inputs: Builds_Comparison_Columns_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Înainte → după`)
};

const fi_builds_comparison_columns_size = /** @type {(inputs: Builds_Comparison_Columns_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ennen → jälkeen`)
};

const sv_builds_comparison_columns_size = /** @type {(inputs: Builds_Comparison_Columns_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Före → efter`)
};

const vi_builds_comparison_columns_size = /** @type {(inputs: Builds_Comparison_Columns_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trước → sau`)
};

const tr_builds_comparison_columns_size = /** @type {(inputs: Builds_Comparison_Columns_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Önce → sonra`)
};

const cs_builds_comparison_columns_size = /** @type {(inputs: Builds_Comparison_Columns_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Před → po`)
};

const bg_builds_comparison_columns_size = /** @type {(inputs: Builds_Comparison_Columns_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Преди → след`)
};

const ru_builds_comparison_columns_size = /** @type {(inputs: Builds_Comparison_Columns_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`До → после`)
};

const uk_builds_comparison_columns_size = /** @type {(inputs: Builds_Comparison_Columns_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`До → після`)
};

const ar_builds_comparison_columns_size = /** @type {(inputs: Builds_Comparison_Columns_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قبل ← بعد`)
};

const hi_builds_comparison_columns_size = /** @type {(inputs: Builds_Comparison_Columns_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पहले → बाद में`)
};

const th_builds_comparison_columns_size = /** @type {(inputs: Builds_Comparison_Columns_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ก่อน → หลัง`)
};

const ja_builds_comparison_columns_size = /** @type {(inputs: Builds_Comparison_Columns_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更前 → 変更後`)
};

const zh_cn2_builds_comparison_columns_size = /** @type {(inputs: Builds_Comparison_Columns_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`之前 → 之后`)
};

const zh_hant1_builds_comparison_columns_size = /** @type {(inputs: Builds_Comparison_Columns_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`之前 → 之後`)
};

const ko_builds_comparison_columns_size = /** @type {(inputs: Builds_Comparison_Columns_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이전 → 이후`)
};

/**
* | output |
* | --- |
* | "Before → after" |
*
* @param {Builds_Comparison_Columns_SizeInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_columns_size = /** @type {((inputs?: Builds_Comparison_Columns_SizeInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_Columns_SizeInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_columns_size(inputs)
	if (locale === "ms") return ms_builds_comparison_columns_size(inputs)
	if (locale === "da") return da_builds_comparison_columns_size(inputs)
	if (locale === "de") return de_builds_comparison_columns_size(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_columns_size(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_columns_size(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_columns_size(inputs)
	if (locale === "fil") return fil_builds_comparison_columns_size(inputs)
	if (locale === "fr") return fr_builds_comparison_columns_size(inputs)
	if (locale === "it") return it_builds_comparison_columns_size(inputs)
	if (locale === "hu") return hu_builds_comparison_columns_size(inputs)
	if (locale === "nl") return nl_builds_comparison_columns_size(inputs)
	if (locale === "no") return no_builds_comparison_columns_size(inputs)
	if (locale === "pl") return pl_builds_comparison_columns_size(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_columns_size(inputs)
	if (locale === "pt") return pt_builds_comparison_columns_size(inputs)
	if (locale === "ro") return ro_builds_comparison_columns_size(inputs)
	if (locale === "fi") return fi_builds_comparison_columns_size(inputs)
	if (locale === "sv") return sv_builds_comparison_columns_size(inputs)
	if (locale === "vi") return vi_builds_comparison_columns_size(inputs)
	if (locale === "tr") return tr_builds_comparison_columns_size(inputs)
	if (locale === "cs") return cs_builds_comparison_columns_size(inputs)
	if (locale === "bg") return bg_builds_comparison_columns_size(inputs)
	if (locale === "ru") return ru_builds_comparison_columns_size(inputs)
	if (locale === "uk") return uk_builds_comparison_columns_size(inputs)
	if (locale === "ar") return ar_builds_comparison_columns_size(inputs)
	if (locale === "hi") return hi_builds_comparison_columns_size(inputs)
	if (locale === "th") return th_builds_comparison_columns_size(inputs)
	if (locale === "ja") return ja_builds_comparison_columns_size(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_columns_size(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_columns_size(inputs)
	return ko_builds_comparison_columns_size(inputs)
});
export { builds_comparison_columns_size as "builds.comparison.columns.size" }